/**
 * Einheitliche Seitenbezeichnung für Tom (Sprachassistent) und Screen-Data.
 * Zuerst exakte Treffer, dann Präfixe für dynamische Routen.
 */
const EXACT_LABELS: Record<string, string> = {
  '/': 'Start',
  '/dashboard': 'Dashboard',
  '/login': 'Anmeldung',
  '/students': 'Schüler (alt)',
  '/students-v2': 'Schüler',
  '/attendance': 'Anwesenheit',
  '/building-blocks': 'Bausteine',
  '/learning-plans': 'Lernpläne (Weiterleitung zu Bausteinen)',
  '/tasks': 'Aufgaben (Weiterleitung zu Bausteinen)',
  '/settings': 'Einstellungen',
  '/device-manager': 'Gerätemanager',
  '/student-files-queue': 'Akten – Warteschlange',
  '/email-client': 'E-Mail',
  '/E-Mail': 'E-Mail',
  '/dateien': 'Dateien',
  '/Akten': 'Akten',
  '/Akten-Prüfung': 'Akten-Prüfung',
  '/lernbuero': 'Lernbüro',
  '/statistics': 'Statistik',
  '/Schüler_Dashboard': 'Schüler-Dashboard',
  '/Meine Lernpläne': 'Meine Lernpläne (Schüler)',
  '/Skillmap': 'Skillmap (Schüler)',
  '/appointments/student': 'Terminbuchungen (Schüler)',
  '/curricula': 'Curricula',
  '/job-queue': 'Job-Queue (eigene Jobs)',
  '/admin/job-queue': 'Admin Job-Queue',
  '/sitzordnung': 'Sitzordnung',
  '/courses-groups': 'Kurse & Gruppen (Admin)',
  '/units': 'Lerngruppen',
  '/unterrichten': 'Unterrichten',
  '/unterrichten/klassenarbeit': 'Klassenarbeit',
  '/student/classwork': 'Klassenarbeit (Schüler)',
  '/display-steuerung': 'Display-Steuerung',
  '/namen-lernen': 'Namen lernen',
  '/namen-lernen/quiz': 'Namen lernen – Quiz',
  '/namen-lernen/snake': 'Namen lernen – Snake',
  '/foto-optimierung': 'Foto-Optimierung',
  '/elternbriefe/neu': 'Elternbrief – neu',
  '/payments': 'Zahlungen',
  '/license': 'Lizenz',
  '/performance': 'Performance',
  '/Showcase': 'UI Showcase',
  '/admin/kontostand': 'Rechnungsübersicht Assistenzsysteme',
  '/appointments': 'Terminbuchungen',
  '/appointments/all': 'Terminbuchungen – Übersicht',
  '/massenmail': 'Massenmail (Weiterleitung)',
  '/elternbriefe': 'Elternbriefe (Weiterleitung)',
}

const PREFIX_LABELS: Array<{ prefix: string; label: string }> = [
  { prefix: '/curricula/', label: 'Curricula – Editor' },
  { prefix: '/elternbriefe/', label: 'Elternbriefe – Bearbeitung' },
  { prefix: '/appointments/', label: 'Terminbuchungen (öffentlich/Flow)' },
]

export function getTomRouteLabel(pathname: string): string {
  const p = pathname || '/'
  if (EXACT_LABELS[p]) return EXACT_LABELS[p]
  for (const { prefix, label } of PREFIX_LABELS) {
    if (p.startsWith(prefix)) return label
  }
  return p === '/' ? 'Start' : `Seite (${p})`
}
